export const featureFlagConstants = {
  GET_FEATURE_FLAG: "GET_FEATURE_FLAG"
}
